import React, { useState } from "react";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Autocomplete from "@mui/material/Autocomplete";
import lumnisLogo from "assets/images/logo/lumnis.png";
import ProfileImg from "assets/images/profileImg.png";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";

const CustomSearchField = styled(TextField)({
  "& label.Mui-focused": {
    color: "#E1E6EA",
  },
  "& label": {
    color: "#E1E6EA",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#E1E6EA",
  },
  "& .MuiOutlinedInput-root": {
    paddingTop: ".25rem",
    paddingBottom: ".25rem",
    paddingLeft: "1rem",
    "& fieldset": {
      borderColor: "#E1E6EA",
      borderRadius: ".5rem",
    },
    "&:hover fieldset": {
      borderColor: "#E1E6EA",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#E1E6EA",
    },
  },
});

export const Header = () => {
  const [isAuth, setIsAuth] = useState(false);
  const [activePage, setActivePage] = useState("home");
  const seachData = [
    "ADAUSD",
    "BTCUSD",
    "DASHUSD",
    "DOGEUSD",
    "DOTUSD",
    "ETHUSD",
    "LTCUSD",
    "NEOUSD",
    "XMRUSD",
    "XRPUSD",
  ];

  const navLink = [
    { title: "home", url: "/" },
    { title: "about", url: "/about" },
    { title: "insights", url: "/insights" },
    { title: "tutorial", url: "/" },
    { title: "contact", url: "/" },
  ];

  return (
    <Navbar expand="xl">
      <Container fluid>
        <Navbar.Brand className="mr-5">
          <Link to="/">
            <img
              src={lumnisLogo}
              alt="logo"
              width="100%"
              height="auto"
              className="img-fluid obj-fit-cover obj-position-center mw-200"
            />
          </Link>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarScroll" />
        <Navbar.Collapse id="navbarScroll">
          <Nav className="w-100 my-2 my-lg-0 align-items-center">
            {isAuth === false &&
              navLink.map((link) => {
                return (
                  <Nav.Item key={link.title}>
                    <Link
                      to={link.url}
                      className={`${
                        activePage === link.title && "active"
                      } nav-link text-capitalize`}
                      onClick={() => {
                        setActivePage(link.title);
                      }}
                    >
                      {link.title}
                    </Link>
                  </Nav.Item>
                );
              })}

            <Nav.Item className="mx-auto flex-fill">
              <div className="nav-link">
                <Stack sx={{ width: "100%" }} className="ml-xl-auto">
                  <Autocomplete
                    freeSolo
                    id="searchfield"
                    disableClearable
                    options={seachData.map((data) => data)}
                    renderInput={(params) => (
                      <CustomSearchField
                        {...params}
                        label=" "
                        placeholder="Search by ticker..."
                        InputProps={{
                          ...params.InputProps,
                          type: "search",
                          startAdornment: [
                            <InputAdornment
                              position="start"
                              sx={{ color: "#E1E6EA" }}
                              key="1"
                            >
                              <SearchIcon />
                            </InputAdornment>,
                          ],
                        }}
                      />
                    )}
                  />
                </Stack>
              </div>
            </Nav.Item>
            {isAuth === false ? (
              <>
                <Nav.Item>
                  <div className="nav-link">
                    <Button
                      variant="link"
                      className="text-capitalize text-nowrap text-decoration-none mr-3"
                    >
                      Sign up
                    </Button>
                    <Button
                      variant="primary"
                      className="text-capitalize text-nowrap"
                      onClick={() => {
                        setIsAuth(true);
                      }}
                    >
                      Sign in
                    </Button>
                  </div>
                </Nav.Item>
              </>
            ) : (
              <Nav.Item>
                <div className="nav-link text-capitalize">
                  <div
                    className="d-flex align-items-center cursor-pointer"
                    onClick={() => {
                      setIsAuth(false);
                    }}
                  >
                    <img
                      src={ProfileImg}
                      alt="Profile"
                      width="40px"
                      height="40px"
                      className="img-fluid obj-fit-cover obj-position-center mr-2"
                    />
                    <div>
                      <p className="text-black font-weight-bold m-0">
                        Robert Fox
                      </p>
                      <p className="subparagraph m-0">brooklyn@inagata.hub</p>
                    </div>
                  </div>
                </div>
              </Nav.Item>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
